import List from '@mui/material/List';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useLabeledProperties from '../../../../hooks/useLabeledProperties';
import { useClientFields } from '../../../../sic-lib/api/hooks/useClientFields';
import { ViewProperty } from '../../../../sic-lib/types/ViewProperty';
import { hasDistinctFieldId } from '../../../../sic-lib/utils/functionalFilters';
import DraggableViewProperty from './DraggableViewProperty/DraggableViewProperty';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {},
}));

type Props = {
    viewProperties: ViewProperty[];
    onChangeHandler: React.Dispatch<{ viewProperties: ViewProperty[] }>;
};

export default function DraggableViewProperties({ viewProperties, onChangeHandler }: Props) {
    const { classes } = useStyles();

    const { data: clientFields } = useClientFields();

    const labeledProps = useLabeledProperties(viewProperties, clientFields || []);

    const handleReorder = (endIndex: number, startIndex: number) => {
        const viewProps = [...viewProperties];
        viewProps.splice(endIndex, 0, viewProps.splice(startIndex, 1)[0]);
        viewProps.forEach((prp, idx) => {
            prp.orderNum = idx;
        });

        onChangeHandler({ viewProperties: viewProps });
    };

    const handleRemove = (fieldId: number) => {
        const nextState = viewProperties
            .filter(hasDistinctFieldId(fieldId))
            .map((itm, idx) => ({ ...itm, ...{ orderNum: idx } }));

        onChangeHandler({ viewProperties: nextState });
    };

    return (
        <List className={classes.root}>
            {labeledProps.map((prp, idx) => (
                <DraggableViewProperty
                    key={prp.fieldId}
                    config={prp}
                    index={idx}
                    onReorderHandler={handleReorder}
                    onRemoveHandler={handleRemove}
                />
            ))}
        </List>
    );
}
